import React, { Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'

import { Amplify } from 'aws-amplify'
import { Authenticator, useTheme, View, Heading, Text, Image } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import 'sweetalert2/dist/sweetalert2.min.css'

import './scss/style.scss'
import './scssc/coreui.scss'
import './scss/style.css'
import './estilos.css'

import awsmobile from './aws-exports'
import { CuentaActivaProvider } from './context/CuentaActivaContext'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: awsmobile.aws_user_pools_id,
      userPoolClientId: awsmobile.aws_user_pools_web_client_id,
    },
  },
})

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))


const App = () => {


  const formFields = {
    signIn: {
      username: {
        label: "Cédula / Nit:",
        placeholder: "Numero sin puntos",
      },
      password: {
        label: "Contraseña:",
        placeholder: "Mayuscula Minuscula Numero Simbolo",
      },
    },
    signUp: {
      name: {
        label: "Nombre u Organización:",
        placeholder: "Nombre completo:",
        isRequired: true,
        order: 1,
      },

      email: {
        label: "Email:",
        placeholder: "Coloca tu email:",
        type: "email",
        isRequired: true,
        order: 2,
      },

      phone_number: {
        label: "Celular",
        placeholder: "Celular",
        isRequired: true,
        dialCode: "+57",
        order: 3,
      },

      profile: {
        label: "Cédula / Nit",
        placeholder: "Numero sin puntos",
        type: "label",
        isRequired: true,
        order: 4,
      },

      username: {
        label: "Confirmar Cédula / Nit",
        placeholder: "Numero sin puntos",
        type: "label",
        isRequired: true,
        order: 5,
      },

      password: {
        label: "Contraseña:",
        placeholder: "Mayuscula Minuscula Numero Simbolo:",
        type: "password",
        isRequired: false,
        order: 6,
      },

      confirm_password: {
        label: "Confirmar Contraseña:",
        order: 7,
      },
    },
    forceNewPassword: {
      password: {
        label: "Contraseña:",
        placeholder: "Ingresa tu contraseña:",
      },
    },
    forgotPassword: {
      username: {
        label: "Cédula / Nit",
        placeholder: "Numero sin puntos:",
      },
    },
    confirmResetPassword: {
      confirmation_code: {
        placeholder: "Ingrese su Código de Confirmación:",
        label: "Codigo",
        isRequired: false,
      },
      password: {
        label: "Nueva Contraseña",
        placeholder: "Mayuscula Minuscula Numero Simbolo:",
      },
      confirm_password: {
        label: "Confirmar Contraseña",
        placeholder: "Mayuscula Minuscula Numero Simbolo:",
      },
    },
    setupTotp: {
      QR: {
        totpIssuer: "test issuer",
        totpUsername: "amplify_qr_test_user",
      },
      confirmation_code: {
        label: "SMS",
        placeholder: "Ingrese su Código de Confirmación:",
        isRequired: false,
      },
    },
    confirmSignIn: {
      confirmation_code: {
        label: "SMS",
        placeholder: "Ingrese su Código de Confirmación:",
        isRequired: false,
      },
    },
  };


  const components = {
    Header() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Image
            alt="Amplify logo"
            src="https://s3.amazonaws.com/www.codeflex.lat/documentos/05e578da-9428-4e5c-a858-0420f2fa4c81/FAS/img3.png"
            style={{ width: "220px" }}
          />
        </View>
      );
    },

    Footer() {
      const { tokens } = useTheme();

      return (
        <View textAlign="center" padding={tokens.space.large}>
          <Text style={{ color: "black", fontSize: "18px" }}>
            &copy; All Rights Reserved | fasacademy.edu.co
          </Text>
        </View>
      );
    },

    ForgotPassword: {
      Header() {
        const { tokens } = useTheme();
        return (
          <Heading padding={`${tokens.space.xl} 0 0 ${tokens.space.xl}`} level={3}>
            <center style={{ fontSize: "27px" }}>Restablecer la contraseña</center>
          </Heading>
        );
      },
    },

  };


  return (
    <Authenticator
      formFields={formFields} components={components} 
    >
      {({ signOut, user }) => (
        <CuentaActivaProvider>
        <HashRouter>
          <Suspense fallback={loading}>
            <Routes>
              <Route exact path="/login" name="Login Page" element={<Login />} />
              <Route exact path="/register" name="Register Page" element={<Register />} />
              <Route exact path="/404" name="Page 404" element={<Page404 />} />
              <Route exact path="/500" name="Page 500" element={<Page500 />} />
              <Route path="*" name="Home" element={<DefaultLayout />} />
            </Routes>
          </Suspense>
        </HashRouter>
        </CuentaActivaProvider>
      )}
    </Authenticator>
  )
}

export default App
